<aside class="col-md-12 mb-0 h-100-margin px-0 px-sm-4">
  <div id="mainListPrevalidation" class="container-list h-100-margin">
    <div class="d-flex flex-column flex-md-row">
      <app-list-filter [options]="optionsFilter" [typeList]="typeList"
        (refreshList)="refreshList($event)"></app-list-filter>
    </div>

    <ng-container *ngIf="listLoading; else prevalidationContent">
      <app-skeleton-loader variant="cargo-list" [rows]="5"></app-skeleton-loader>
    </ng-container>

    <ng-template #prevalidationContent>
      <div *ngIf="paginationList.getList().length" class="container-list-body" infinite-scroll
        [infiniteScrollDistance]="paginationList.getScrollDistance()"
        [infiniteScrollThrottle]="paginationList.getThrottle()" [scrollWindow]="false" (scrolled)="onScrollDown()">

        <div class="table-responsive prevalidation-table-wrapper">
          <table class="prevalidation-table">
            <thead>
              <tr>
                <th>Consecutivo</th>
                <th>Fecha de finalización</th>
                <th *ngIf="someHasCreatorName">Creador</th>
                <th *ngIf="someHasCreatorDocument">Doc. creador</th>
                <th *ngIf="isValidatedFilterActive">Fecha de validación</th>
                <th class="text-center">Tiempo de mora <i class="fas fa-info-circle color-secondary-dark cursor-pointer"
                    matTooltip="Tiempo que ha transcurrido desde la finalización del servicio más el tiempo de vencimiento de la factura hasta la fecha actual."
                    matTooltipClass="tooltip__alert" matTooltipPosition="right"></i></th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cargo of paginationList.getList(); trackBy: trackByCargo" class="prevalidation-row">
                <td class="text-bold">{{ cargo?.consecutive || '-' }}</td>
                <td>
                  <ng-container *ngIf="isInRoute(cargo); else finishDate">
                    Sin finalizar
                  </ng-container>
                  <ng-template #finishDate>
                    {{ getFinishDate(cargo) ? (getFinishDate(cargo) | dateFormat: 'date-time-full-24') : '-' }}
                  </ng-template>
                </td>
                <td *ngIf="someHasCreatorName">{{ getCreatorName(cargo) || '-' }}</td>
                <td *ngIf="someHasCreatorDocument">{{ getCreatorDocument(cargo) }}</td>
                <td *ngIf="isValidatedFilterActive">
                  {{ getValidationDate(cargo) ? (getValidationDate(cargo) | dateFormat: 'date-time-full-24') : '-' }}
                  <i class="fas fa-info-circle color-secondary-dark cursor-pointer" *ngIf="getValidationTooltip(cargo)"
                    [matTooltip]="getValidationTooltip(cargo)" matTooltipClass="tooltip__alert"></i>
                </td>
                <td class="text-center">
                  <span class="delay-badge" [ngClass]="getDelayTime(cargo).badge">
                    {{ getDelayTime(cargo).message }}
                  </span>
                </td>
                <td class="text-center" (click)="goToDetail(cargo)">
                  <i class="fas fa-chevron-right prevalidation-arrow"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngIf="!paginationList.getList().length" class="container_no_results">
        <div class="icon"><i class="fas fa-calendar-times"></i></div>
        <h4 class="text-bold text-center">No hay resultados que coincidan con la búsqueda</h4>
      </div>
    </ng-template>
  </div>
</aside>